import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {ChangePasswordService} from './change-password.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderService} from '../../header/header.service';
import {NotifierService} from '../../notifier/notifier.service';
import {NotificationType} from '../../notifier/notification-type.enum';
import {PasswordValidator} from "../../../common/password.validator";
import {ResetChange} from "../reset-change.enum";

@Component({
  selector: 'pbc-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  tokenForChangePassword : string;
  tokenValid = false;
  passwordChanged =false;
  mode : ResetChange = ResetChange.RESET;
  header : string = "Reset hasła";
  resetChange = ResetChange;

  static readonly resetPasswordHeader = "Reset hasła";
  static readonly changePasswordHeader = "Zmiana hasła";

  constructor(private changePasswordService : ChangePasswordService,
              private activatedRoute: ActivatedRoute,
              private headerService: HeaderService,
              private notifierService: NotifierService,
              private router: Router
              ) {
    this.changePasswordForm = new FormGroup({
      password: new FormControl('', [Validators.required,
        PasswordValidator.strong,
        Validators.minLength(6)]),
      confirmPassword: new FormControl('', [Validators.required,PasswordValidator.strong, Validators.minLength(6)])
    });
    this.changePasswordForm.setValidators(ChangePasswordComponent.validate);
  }

  /**
   * Waliduje cały formularz. Formularz jest poprawny wttw kiedy hasło i pole w którym je potwierdzamy mają takie same
   * wartości.
   * @param formControl
   */
  static validate(formControl: AbstractControl) : {[key: string] : any} {

    let password = formControl.value['password'];
    let confirmPassword = formControl.value['confirmPassword'];

    if (password==confirmPassword) {
      return null;
    } else {
      return {passwordNotConfirmed: true};
    }

  }

  ngOnInit() {
    this.headerService.isHomepage(false);

    this.activatedRoute.url.subscribe(url => {
      if (url[0].path === 'reset-password')
        this.mode = ResetChange.RESET;
      else
        this.mode = ResetChange.CHANGE;

      if (this.mode == ResetChange.CHANGE)
        this.header = ChangePasswordComponent.changePasswordHeader;
      else
        this.header = ChangePasswordComponent.resetPasswordHeader;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.tokenForChangePassword = params['token'];
      if (this.tokenForChangePassword) {
        this.changePasswordService.validateChangePassword(this.tokenForChangePassword).subscribe(
          (response: {status: number, message: string}) => {
            if (response.status!=1) {
              this.tokenValid = false;
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, response.message);
            } else {
              this.tokenValid = true;
            }
          },
          (error) => {
            console.log(error);
            this.tokenValid = false;
          }
        )
      } else {
        this.tokenValid = false;
      }
    });
  }

  changePassword() {
    let password = this.changePasswordForm.controls['password'].value;
    this.changePasswordService.changePassword(password, this.tokenForChangePassword).subscribe(
      (response: {status: number, message: string}) => {
        if (response.status==1) {
          this.passwordChanged = true;
        } else {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, response.message);
        }
      }
    );
  }

}
